import { CustomCell, CustomRenderer, GridCellKind } from '@glideapps/glide-data-grid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { getFileName } from '@/core/models/columns/attachment'
import { ILookupCell } from '@/core/models/columns/lookup'
import { RatingCell } from '@/core/models/columns/rating'

import { drawBubbles } from '../helpers/draw-bubble'
import { drawImage } from '../helpers/draw-image'
import { drawFile } from './CustomFileRenderer'
import { drawIcon } from './CustomIconRenderer'
import { drawRating } from './CustomRatingRenderer'

// import { drawBarcode } from './CustomBarcodeRenderer'
// import { drawQRCode } from './CustomQRCodeRenderer'

export interface CustomLookupCellProps {
  readonly type: ColumnTypes
  readonly cell: ILookupCell
}

export type CustomLookupCell = CustomCell<CustomLookupCellProps>

const CustomLookupRenderer: CustomRenderer<CustomLookupCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is CustomLookupCell =>
    (cell.data as CustomLookupCellProps).type === ColumnTypes.Lookup,
  draw: (args: any, cell) => {
    const lookupCell = cell.data.cell as ILookupCell
    const resolvedType = lookupCell.resolvedType
    const values = lookupCell.value as any[]

    if (!values || !values.length) return

    switch (resolvedType) {
      case ColumnTypes.Image:
        drawImage(args, values as string[], 4)
        break

      case ColumnTypes.Icon:
        drawIcon(args, values[0])
        break

      case ColumnTypes.Rating:
        drawRating(args, new RatingCell(values[0], lookupCell.resolvedSettings as any))
        break

      case ColumnTypes.Attachment: {
        drawFile(args, getFileName(values[0]))
        break
      }

      // case cellValues[0] instanceof ImageArrayCell: {
      //   const urls = JSON.parse(cellValues[0].toString())?.map((cellValue: any) => cellValue.Url)
      //   drawImage(args, Array.isArray(urls) ? urls : [], 4, args.cell.contentAlign)
      //   break
      // }

      // case cellValues.length > 0 && cellValues[0] instanceof QRCodeCell:
      //   if (cellValues[0].value) {
      //     drawQRCode(args, cellValues[0].value)
      //   }
      //   break

      // case cellValues.length > 0 && cellValues[0] instanceof BarcodeCell:
      //   if (cellValues[0].value) {
      //     drawBarcode(args, cellValues[0].value, cellValues[0].barcodeOptions)
      //   }
      //   break

      default:
        drawBubbles(args, lookupCell.toValues())
        break
    }
  },
}

export default CustomLookupRenderer
